import { render, staticRenderFns } from "./CollectionNavigation.vue?vue&type=template&id=dbdbc7aa&"
import script from "./CollectionNavigation.vue?vue&type=script&lang=ts&"
export * from "./CollectionNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports